export default __webpack_public_path__ + "static/media/ql_12.537cc372.png";